import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const csmReportsSatisfactionTimeScaleRoute: InvariantJiraRoute = {
	name: 'csm-reports-satisfaction-time-scale',
	path: '/jira/customer-service-management/projects/:projectKey/reports/all-rating/timescale/:timescaleId',
};
